import PropTypes from 'prop-types';
import React from 'react';
import { ORANGE_C, GREY_I, PURE_WHITE } from 'app/constants/Colors';

function ToggleSwitch({ toggledOn }) {
  return (
    <svg width="42px" height="20px" viewBox="0 0 2 1" xmlns="http://www.w3.org/2000/svg">
      <line
        x1={0.5}
        x2={1.5}
        y1={0.5}
        y2={0.5}
        stroke={toggledOn ? ORANGE_C : GREY_I}
        strokeWidth={1}
        strokeLinecap="round"
      />

      <circle
        cx={toggledOn ? 1.5 : 0.5}
        cy={0.5}
        r={0.4}
        fill={PURE_WHITE}
        style={{
          transition: 'cx 0.1s linear',
        }}
      />
    </svg>
  );
}

ToggleSwitch.propTypes = {
  toggledOn: PropTypes.bool.isRequired,
};

export default ToggleSwitch;
